import { useState } from 'react';
import { CreativeWithExternalId } from '../services/measurementService';
import {
  filterAllowedCreativeFiles,
  UNSUPPORTED_CREATIVE_MESSAGE,
} from '../utils/creativeFileValidation';

export function usePendingCreatives() {
  const [creatives, setCreatives] = useState<CreativeWithExternalId[]>([]);
  const [error, setError] = useState('');

  const addCreative = (creative: CreativeWithExternalId) => {
    setCreatives(prev => [...prev, creative]);
    setError('');
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    const { allowed, rejected } = filterAllowedCreativeFiles(files);
    if (rejected.length > 0) {
      setError(
        `${UNSUPPORTED_CREATIVE_MESSAGE} Rejected: ${rejected.map(f => f.name).join(', ')}.`
      );
    } else {
      setError('');
    }
    if (allowed.length === 0) {
      e.target.value = '';
      return;
    }
    setCreatives(prev => [
      ...prev,
      ...allowed.map(file => ({ file, externalId: '' })),
    ]);
    e.target.value = '';
  };

  const removeCreative = (index: number) => {
    setCreatives(prev => prev.filter((_, i) => i !== index));
  };

  const updateCreativeExternalId = (index: number, externalId: string) => {
    setCreatives(prev =>
      prev.map((creative, i) => (i === index ? { ...creative, externalId } : creative))
    );
  };

  const clearCreatives = () => setCreatives([]);

  const hasMissingExternalIds = creatives.some(c => !c.externalId.trim());
  const canSubmit = creatives.length > 0 && !hasMissingExternalIds;

  return {
    creatives,
    error,
    setError,
    addCreative,
    handleFileChange,
    removeCreative,
    updateCreativeExternalId,
    clearCreatives,
    hasMissingExternalIds,
    canSubmit,
  };
}
